import axios from "axios";
import { inject, reactive, provide, toRefs } from "@vue/composition-api";
import { actions as appActions, state as appState } from "@/store/modules/app";
import { setCookie, getCookie } from "@/helpers/helpers";

const PROTOCOL = process.env.VUE_APP_WS_PROTOCOL ? process.env.VUE_APP_WS_PROTOCOL : "";
const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
const BASE_URL = `${PROTOCOL}://${HOST}`;

export const state = reactive({
    importStep: 1,
    latestImport: {},
    importReady: false,

    email: null,
    password: null,
})
export const actions = {
    validateCredentials: async ({ email, password }) => {
        const response = await axios.post("/import/smart_accounts/test_connection", { email: email, password: password })
        return response.data
    },
    startSmartAccountsImport: async (payload) => {
        return await axios.post(`/import/smart_accounts/`, payload)
    },
    getOnGoingImportStatus: async (companyId) => {
        const response = await axios.get('/import/integration/status', { params: { account_id:companyId, type:'smart_accounts' }})
        return response.data
    },
    connectWs () {
        setCookie("ongoing_import", 1);
        if (state.import_ws) return
        state.import_ws = new WebSocket("{0}/ws/import".format(BASE_URL));

        state.import_ws.onopen = function () {
            console.log("Import WebSocket: connected");
            state.reconnect_counter = 0;
        };

        state.import_ws.onmessage = function (ev) {

            let data = JSON.parse(ev.data);
            state.currentImport = data
            state.latestImport = data
            actions.setImportStep(4)
        };

        state.import_ws.onclose = function () {
            if(state.no_reconnect){
                console.log("Import WebSocket: connection closed");
                state.no_reconnect = false
                return
            }
            console.log("Import WebSocket: connection lost");
            if (state.reconnect_counter >= appState.reconnect_max_tries) {
                appActions.showGlobalConnectionLost();
            } else {
                state.reconnect_counter++;
            }
            setTimeout(function () {
                console.log("Import WebSocket: reconnecting...({0})".format(state.reconnect_counter));
                actions.connectWs();
            }, appState.reconnect_wait);
        };
    },
    closeWs() {
        setCookie("ongoing_import", 0);
        if (!state.import_ws) return
        state.no_reconnect = true
        state.import_ws.close()
        state.import_ws = null
    },

    setImportStep(step, payload) {
        state.importStep = step
        state.importReady = false
        actions.closeWs()
        if (step === 1) {
            state.email = null
            state.password = null
        } else if (step === 2) {
            state.email = payload.email
            state.password = payload.password
        } else if (step === 3) {
            actions.connectWs()
        } else if (step === 4) {
            state.importReady = true
        }
    },
    setLatestImport(value){
        state.latestImport = value
    },
}

export const key = Symbol("SmartAccountsStore");

export const provideSmartAccountsStore = () => {
    provide(key, {
        ...toRefs(state),
        ...actions
    });
};

if (parseInt(getCookie('ongoing_import')) === 1){
    actions.connectWs()
} else {
    actions.closeWs()
}
export default () => inject(key);

